/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type CategoryTiles_viewer = {
    readonly trendingFurniture?: ReadonlyArray<{
        readonly displayName: string | null;
        readonly url: string | null;
        readonly image: string | null;
    } | null> | null;
    readonly trendingArt?: ReadonlyArray<{
        readonly displayName: string | null;
        readonly url: string | null;
        readonly image: string | null;
    } | null> | null;
    readonly trendingFashion?: ReadonlyArray<{
        readonly displayName: string | null;
        readonly url: string | null;
        readonly image: string | null;
    } | null> | null;
    readonly trendingJewelry?: ReadonlyArray<{
        readonly displayName: string | null;
        readonly url: string | null;
        readonly image: string | null;
    } | null> | null;
    readonly " $refType": "CategoryTiles_viewer";
};
export type CategoryTiles_viewer$data = CategoryTiles_viewer;
export type CategoryTiles_viewer$key = {
    readonly " $data"?: CategoryTiles_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"CategoryTiles_viewer">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Literal",
  "name": "categoryLevels",
  "value": 2
},
v1 = {
  "kind": "Literal",
  "name": "numItems",
  "value": 2
},
v2 = {
  "kind": "Literal",
  "name": "trendType",
  "value": "CATEGORY"
},
v3 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "displayName",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "url",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "image",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "showModules"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "CategoryTiles_viewer",
  "selections": [
    {
      "condition": "showModules",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "trendingFurniture",
          "args": [
            (v0/*: any*/),
            (v1/*: any*/),
            {
              "kind": "Literal",
              "name": "parentCategory",
              "value": "FURNITURE"
            },
            (v2/*: any*/)
          ],
          "concreteType": "TrendingModules",
          "kind": "LinkedField",
          "name": "trending",
          "plural": true,
          "selections": (v3/*: any*/),
          "storageKey": "trending(categoryLevels:2,numItems:2,parentCategory:\"FURNITURE\",trendType:\"CATEGORY\")"
        },
        {
          "alias": "trendingArt",
          "args": [
            (v0/*: any*/),
            (v1/*: any*/),
            {
              "kind": "Literal",
              "name": "parentCategory",
              "value": "ART"
            },
            (v2/*: any*/)
          ],
          "concreteType": "TrendingModules",
          "kind": "LinkedField",
          "name": "trending",
          "plural": true,
          "selections": (v3/*: any*/),
          "storageKey": "trending(categoryLevels:2,numItems:2,parentCategory:\"ART\",trendType:\"CATEGORY\")"
        },
        {
          "alias": "trendingFashion",
          "args": [
            (v0/*: any*/),
            (v1/*: any*/),
            {
              "kind": "Literal",
              "name": "parentCategory",
              "value": "FASHION"
            },
            (v2/*: any*/)
          ],
          "concreteType": "TrendingModules",
          "kind": "LinkedField",
          "name": "trending",
          "plural": true,
          "selections": (v3/*: any*/),
          "storageKey": "trending(categoryLevels:2,numItems:2,parentCategory:\"FASHION\",trendType:\"CATEGORY\")"
        },
        {
          "alias": "trendingJewelry",
          "args": [
            (v0/*: any*/),
            (v1/*: any*/),
            {
              "kind": "Literal",
              "name": "parentCategory",
              "value": "JEWELRY"
            },
            (v2/*: any*/)
          ],
          "concreteType": "TrendingModules",
          "kind": "LinkedField",
          "name": "trending",
          "plural": true,
          "selections": (v3/*: any*/),
          "storageKey": "trending(categoryLevels:2,numItems:2,parentCategory:\"JEWELRY\",trendType:\"CATEGORY\")"
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();
(node as any).hash = '40c6706e39bdd8b184ed959bc909c421';
export default node;
